import React from "react"
import { Map, View, Window, Grid, Col, Text } from "react-ame-components"

export class MapExample extends React.Component {
  state = {
    center: {
      lat: -22.94173,
      lng: -43.17853,
    },
    zoom: 12,
    markers: [
      {
        lat: -22.970722,
        lng: -43.182365,
        options: {
          title: "Copacabana",
          draggable: true,
          clickable: false,
          icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/parking_lot_maps.png",
        },
      },
      {
        lat: -22.9511,
        lng: -43.1809,
        options: {
          title: "Botafogo",
          draggable: true,
        },
      },
    ],
    map: null,
    newMarker: null,
    remove: false,
  }

  onMarkerPressHandler = marker => {
    console.log(marker)
    let info = new window.google.maps.InfoWindow({
      content: marker.title,
    })
    info.open(this.state.map, marker)
  }

  render() {
    const { center, zoom } = this.state

    return (
      <Window>
        <View
          direction="column"
          align="center"
          justify="center"
          marginTop="big">
          <Grid>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
            <Col columnSize={{ sm: 10, md: 6 }}>
              <View
                backgroundColor="neutral-100"
                padding="big"
                borderRadius="small"
                shadow="level-2"
                direction="column"
                align="center">
                <Text
                  fontSize="large"
                  lineHeight="large"
                  fontWeight="bold">
                  Componente [color=primary]Map[/color]
                </Text>
                <Text>Este componente serve para exibir um Map</Text>
                <Map
                  apiKey={""}
                  mapOptions={{
                    center,
                    zoom,
                  }}
                  onMarkerPress={this.onMarkerPressHandler}
                  markers={this.state.markers}
                  width={400}
                  height={400}
                  markerInfo={true}
                  getMap={map => {
                    this.setState({ map })
                  }}
                />
              </View>
            </Col>
            <Col columnSize={{ sm: 1, md: 3 }}></Col>
          </Grid>
        </View>
      </Window>
    )
  }
}
